import { render, staticRenderFns } from "./AppPurchaseForm.vue?vue&type=template&id=dd38753e&"
import script from "./AppPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./AppPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports